<!--
 * @Author: ZS
 * @Date: 2020-06-09 14:44:54
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-15 17:37:44
 * @Description: file content
-->
<template>
  <div>
    <div class="mainContent topPart">
      <div class="headerAndNav">
        <v-header></v-header>
        <v-nav></v-nav>
      </div>
      <div class="topQuery">
        <div class="clearfix mainWidth">
          <h2 class="partName">
            {{ departName }}/<span>一网通办管理项目</span>
          </h2>
          <div class="left pull-left">
            <v-searchBar></v-searchBar>
            <div class="hotIssues">
              <p class="tit clearfix">
                <span>
                  <i class="iconfont icon-tongzhi"></i>
                  办事动态
                </span>
                <a
                  class="more pull-right"
                  :href="newsMore"
                  style="color: #d90000"
                  target="_blank"
                  >更多&gt;</a
                >
              </p>
              <ul class="clearfix">
                <li
                  v-for="(item, index) in newsList"
                  :key="index"
                  @click="newsJump(item.href)"
                >
                  <i></i><span>{{ item.title }}</span
                  ><b>{{ item.newDate }}</b>
                </li>
              </ul>
              <div class="noData bsqsData" v-if="noBs">
                <img src="../../assets/images/bsqs.png" alt="" />
                <p>暂无办事动态</p>
              </div>
            </div>
          </div>
          <div
            class="right pull-right notLogin"
            style="display: block"
            v-if="!$store.state.isLogin"
          >
            <h3 class="tit">办事直达</h3>
            <div class="directBox clearfix">
              <div class="box1 loginBox">
                <h3>用户登录</h3>
                <form :action="action" id="loginForm">
                  <div class="uerName">
                    <el-input
                      v-model="userName"
                      placeholder="请输入用户名"
                    ></el-input>
                  </div>
                  <div class="passWord">
                    <el-input
                      v-model="passWord"
                      placeholder="请输入密码"
                      show-password
                    ></el-input>
                  </div>
                  <!-- <input type="hidden" name="lt" id="lt" value="" v-model="lt">
                <input type="hidden" name="execution" id="execution" v-model="execution"> -->
                  <!--                  <input type="hidden" name="_eventId" value="submit">-->
                </form>
                <el-row>
                  <el-button class="loginBtn" @click="login()">登录</el-button>
                  <el-button class="forgetBtn" @click="forgetPasswordFunc"
                    >忘记密码</el-button
                  >
                </el-row>
              </div>
              <div class="box3">
                <img src="../../assets/images/yjsycb.png" alt="" />
                <div class="appQrcode">
                  <img src="../../assets/images/code-syb.png" alt="" />
                  <p>扫描左侧二维码<br />下载i轻工大APP</p>
                  <div class="downLoadNowBtn" @click="downloadAppFunc">
                    立即下载<i class="iconfont icon-shou"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="right pull-right logined"
            style="display: block"
            v-if="$store.state.isLogin"
          >
            <div class="grxx pull-left">
              <div class="ywtbUserInfo">
                <a href="javascript:void(0)" class="user-photo-wrap">
                  <img
                    class="userPhoto"
                    src="/portal-ywtb/web/userProFile/getUserProfile"
                  />
                </a>
                <!-- <img class="userPhoto" src="../../assets/images/zxzq.png"> -->
                <p class="name">{{ $store.state.nickName }}</p>
                <div class="role clearfix">
                  <span v-for="(item, index) in roleNameList" :key="index">{{
                    item.roleName
                  }}</span>
                </div>
                <div
                  class="dPart"
                  v-for="(item, index) in $store.state.departName"
                  :key="index"
                >
                  {{ item.deptName }}
                </div>
                <div class="myHomepage" @click="routeToMyHome">我的主页</div>
              </div>
              <ul class="userMatterList clearfix">
                <li @click="goUser(4, 0)">
                  <div class="num">{{ userNums.wddb }}</div>
                  <p>我的待办</p>
                </li>
                <li @click="goUser(0, 0)">
                  <div class="num">{{ userNums.blz }}</div>
                  <p>办理中</p>
                </li>
                <li class="myAdvisory" @click="goUser(0, 1)">
                  <div class="num">{{ userNums.ybj }}</div>
                  <p>已办结</p>
                </li>
                <li @click="goUser(1, 0)" class="marginR0">
                  <div class="num">{{ userNums.wdzx }}</div>
                  <p>我的咨询</p>
                </li>
                <li v-show="false">
                  <div class="num">0</div>
                  <p>我的消息</p>
                </li>
              </ul>
              <div style="overflow: hidden; height: 90px">
                <v-userTip :num="3"></v-userTip>
              </div>
              <!-- <div class="usertip">
                <span>
                  <i class="iconfont icon-icon_notice"></i>
                  审批不通过：
                </span>
                <b>《学校官网域名申请》办理</b>
                <div class="time pull-right">06-12</div>
              </div>
              <div class="usertip">
                <span class="pass">
                  <i class="iconfont icon-icon_notice"></i>
                  审批通过：
                </span>
                <b>《学生离校手续办理》</b>
                <div class="time pull-right">06-12</div>
              </div>
              <div class="usertip">
                <span>
                  <i class="iconfont icon-icon_notice"></i>
                  审批不通过：
                </span>
                <b>《学校官网域名申请》办理</b>
                <div class="time pull-right">06-12</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mainWidth typeOfService guideline_list_wrap"
      :class="`template${templateData.templateType || 1}`"
    >
      <div class="guideline_list_box">
        <div class="TabTit">
          <dl class="clearfix">
            <dt>
              <img src="../../assets/images/titleicon2.png" alt="" />
              办事事项
            </dt>
          </dl>
        </div>
        <div v-if="guidelineList.length">
          <!-- <component
            :is="`Template${templateData.templateType || 1}`"
            :guidelineList="guidelineList"
          ></component> -->
          <ul class="ywtbListsContent clearfix noselect">
            <li
              class="searchShow"
              v-for="(item, index) in guidelineList"
              :key="index"
            >
              <img :src="`/portal-ywtb/${item.guidelineImg}`" />
              <div
                class="collection_wrap"
                v-if="$store.state.isLogin"
                :class="{
                  active: item.portalPcHandlingGuidelineCollection === 1,
                }"
                @click="scFunc(item)"
              >
                <i
                  class="iconfont icon-sc"
                  :class="{
                    active: item.portalPcHandlingGuidelineCollection === 1,
                  }"
                ></i
                ><span v-if="item.portalPcHandlingGuidelineCollection === 1"
                  >&nbsp;取消收藏</span
                ><span v-else>&nbsp;&nbsp;收藏</span>
              </div>
              <h3 :title="item.portalPcHandlingGuidelineName">
                {{ item.portalPcHandlingGuidelineName }}
              </h3>
              <!-- 部门名称 -->
              <div class="dept_name_wrap">{{ item.department }}</div>
              <!-- 评分 -->
              <div class="score_wrap">
                <el-rate
                  :value="item.guidelineSatisfaction || 0"
                  disabled
                  :show-score="false"
                  text-color="#ff9900"
                >
                </el-rate>
              </div>
              <a
                v-if="String(item.portalPcHandlingGuideline) === '1'"
                href="javascript:;"
                class="btn btn-primary znBtn"
                @click="bsznFunc(item)"
                >办事指南</a
              >
              <a
                v-if="
                  [null, undefined, ''].indexOf(item.guidelineUrl) === -1 &&
                  item.ljbl === 1
                "
                :href="item.guidelineUrl"
                class="btn btn-primary blBtn"
                @click="globalAddVisit(item.portalPcHandlingGuidelineCode)"
                target="_blank"
                >立即办理</a
              >
            </li>
          </ul>
        </div>
        <div class="nullData" v-else>
          <img src="../../../static/images/yyqs.png" alt="" />
          <p>暂无适用您的相关事项服务</p>
        </div>
        <!-- 分页 -->
        <!-- <div
          class="page_wrap"
          v-if="guidelineList.length && templateData.whetherPage === 1"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
    <!-- <Fwcxtj></Fwcxtj> -->
    <v-footer :hasInfo="0"></v-footer>
    <v-toolBar></v-toolBar>
  </div>
</template>

<script>
import Footer from "../common/Footer";
import Header from "../common/Header";
import TopNav from "../common/TopNav";
import ToolBar from "../common/ToolBar";
import UserTip from "../page/home/UserTip";
import SearchBar from "../page/home/SearchBar";
import qs from "qs";
import { ywtbRequest, request } from "@/api/axios.js";
import HomeMixin from "./home-mixin.js";
import Fwcxtj from "./Fwcxtj.vue";
import {
  getDeptByCode,
  webQueryDeptTemplateInfo,
  findDepartmentGuidelineSequenceList,
} from "@/api/deptHome.js";
// 引入部门事项模板
import Template1 from "./dept-home-guideline/template-1.vue";
import Template2 from "./dept-home-guideline/template-2.vue";
import Template3 from "./dept-home-guideline/template-3.vue";
export default {
  components: {
    "v-footer": Footer,
    "v-header": Header,
    "v-nav": TopNav,
    "v-toolBar": ToolBar,
    "v-userTip": UserTip,
    "v-searchBar": SearchBar,
    Fwcxtj,
    Template1,
    Template2,
    Template3,
  },
  mixins: [HomeMixin],
  computed: {
    roleNameList() {
      const list = this.$store.state.roleName || [];
      const arr = list.filter((item) => item.roleType !== "2");
      return arr;
    },
  },
  data() {
    return {
      listFlag: false,
      userId: 1000,
      newsList: "",
      nickName: "李四",
      rolename: "管理员",
      departName: "",
      serviceIndex: "", //三个服务索引
      typeOfService: [
        {
          sname: "学生服务",
          description: "指不需要多人审批但是需要专人操作完成的服务",
          imgUrl: require("../../assets/images/serviceTit1.png"),
          totalNum: 99,
        },
        {
          sname: "教职工服务",
          description: "指跨部门或本部门多人审批的服务事项",
          imgUrl: require("../../assets/images/serviceTit2.png"),
          totalNum: 20,
        },
        {
          sname: "公共服务",
          description: "指提供查询结果的服务事项",
          imgUrl: require("../../assets/images/serviceTit3.png"),
          totalNum: 51,
        },
      ],
      navIndex: 0,
      departList: "", //部门列表
      roleList: [],
      TabTitIdx0: 0,
      TabTitIdx1: 0,
      TabTitIdx2: 0,
      inputVal: "",
      ztList: "",
      getGuidelineList: [],
      userName: "",
      passWord: "",
      lt: "",
      execution: "",
      action: "",
      cCode0: "",
      pCode0: "",
      cCode1: "",
      pCode1: "",
      cCode2: "",
      pCode2: "",
      pie_1: {
        day: 0,
        hour: 0,
        num: 0,
      },
      pie_3: {
        num: 3,
        num1: 2,
      },
      roleAuthFlag: [true, true, true],
      heightFlag: 0, //容器高度
      newsMore: "",
      userNums: {
        wddb: 0,
        blz: 0,
        ybj: 0,
        wdzx: 0,
      },
      noYy: false, //没有应用的时候
      noBs: false, //没有办事动态的时候
      // 当前部门的模板配置项
      templateData: {},
      // 事项列表
      guidelineList: [],
      // 分页数据
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
    };
  },
  provide() {
    return {
      bsznFunc: this.bsznFunc,
      zxblFunc: this.zxblFunc,
      scFunc: this.scFunc,
    };
  },
  mounted() {
    // this.drawPie(4, 'pie4', "16")
    // this.drawPie(2, 'pie2', "32")
    // this.drawPies1()
    // this.drawPies2()
    this.getDepartNew();
    // this.getStatistics()
    // this.getBjNums(2)
    // this.departName = localStorage.getItem("departName");
    this.getDeptByCode();
    if (this.$store.state.isLogin) {
      // this.getGuideline1();
      this.getUserNums();
    } else {
      // this.getGuideline();
    }
    this.webQueryDeptTemplateInfo();
  },
  methods: {
    forgetPasswordFunc() {
      this.globalDownload({
        url: window.forgetPasswordUrl,
      });
    },
    /**
     * @name scFunc
     * @description 收藏/取消收藏
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-10-22 18:28:55
     */
    scFunc(param) {
      this.publicJs.collection(
        {
          portalPcHandlingGuidelineCode: param.guidelineCode,
          portalPcHandlingGuidelineCollection:
            param.portalPcHandlingGuidelineCollection,
        },
        (collection) => {
          param.portalPcHandlingGuidelineCollection = collection;
        }
      );
    },
    /**
     * @name handleCurrentChange
     * @description 切换哪一页
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-10-22 18:19:07
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.findDepartmentGuidelineSequenceList();
    },
    /**
     * @name handleSizeChange
     * @description 切换每页展示条数
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-10-22 18:18:40
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    /**
     * @name findDepartmentGuidelineSequenceList
     * @description 获取事项列表
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-10-22 18:00:09
     */
    async findDepartmentGuidelineSequenceList() {
      let data = {
        departmentCode: this.$route.query.code,
        guidelineState: 1,
      };
      if (this.templateData.whetherPage === 1) {
        // 有分页
        Object.assign(data, {
          pageNum: this.currentPage,
          pageSize: 9999,
        });
      }
      const res = await findDepartmentGuidelineSequenceList({
        ...data,
      });
      this.guidelineList = res.data.list || [];
      this.totalSize = res.data.total;
    },
    /**
     * @name bsznFunc
     * @description 点击办事指南
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-10-22 17:51:40
     */
    bsznFunc(param) {
      this.$router.push({
        path: "/guide",
        query: {
          code: param.guidelineCode,
        },
      });
    },
    // 点击个人主页跳转
    routeToMyHome() {
      this.$router.push({
        path: "/user",
      });
    },
    /**
     * @name zxblFunc
     * @description 点击在线办理
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-10-22 17:51:40
     */
    zxblFunc(param) {
      const { guidelineUrl } = param;
      if (guidelineUrl === null || guidelineUrl === undefined) {
        this.$message({
          type: "warning",
          message: "该事项访问地址有问题，请联系管理员",
        });
        return;
      }
      // 打开一个新的窗口
      this.globalDownload({
        method: "post",
        url: guidelineUrl,
      });
    },
    /**
     * @name webQueryDeptTemplateInfo
     * @description 查询当前配置的模板，以及是否分页信息
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-10-22 14:47:28
     */
    async webQueryDeptTemplateInfo() {
      const deptCode = this.$route.query.code;
      if (!deptCode) {
        this.$message({
          type: "warning",
          message: "当前访问地址不正确，请联系管理员",
        });
        return;
      }
      const res = await webQueryDeptTemplateInfo({
        deptCode,
      });
      this.templateData = res.data ? (res.data[0] ? res.data[0] : {}) : {};
      this.findDepartmentGuidelineSequenceList();
    },
    /**
     * @name getDeptByCode
     * @description 根据部门code获取部门名称等信息
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-22 10:44:12
     */
    async getDeptByCode() {
      const deptCode = this.$route.query.code;
      if (!deptCode) {
        return;
      }
      const res = await getDeptByCode({
        deptCode,
      });
      if (res.data && res.data.deptCode) {
        this.departName = res.data.deptName;
      }
    },
    /**
     * @name checkLogin
     * @description 获取是否登录状态
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-03 11:09:35
     */
    async checkLogin() {
      return new Promise((resolve, reject) => {
        ywtbRequest("/portal-ywtb/web/getSession").then((res) => {
          localStorage.setItem("res", JSON.stringify(res));
          this.$store.commit("changeLogin");
          if (res.status === 200) {
            // 已登录
            resolve(1);
          } else {
            reject();
          }
        });
      });
    },
    //获取首页的事项列表
    getGuideline() {
      let sendData = qs.stringify({
        sceneParentCode: "root",
        deptCode: localStorage.getItem("departCode"),
        pageNumber: 0,
        pageSize: 9,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guideline/findPortalHandlingGuidelineByScene",
        sendData
      ).then((res) => {
        this.listFlag = true;
        let data = res.dataList;
        // console.log(data)
        for (let i = 0; i < data.length; i++) {
          let data1 = data[i].sceneList;
          for (let j = 0; j < data1.length; j++) {
            let data2 = data1[j].guidelineList;
            for (let k = 0; k < data2.length; k++) {
              // data2[k].portalPcHandlingGuidelineImg = '/portal-ywtb/public/getImg?path=' +
              //   encodeURI(data2[k].portalPcHandlingGuidelineImg)
              data2[
                k
              ].portalPcHandlingGuidelineImg = `/portal-ywtb/${data2[k].portalPcHandlingGuidelineImg}`;
            }
          }
        }
        this.getGuidelineList = data;
        this.cCode0 = data[0].sceneList[0].pcGuidelineSceneCode;
        this.pCode0 = data[0].sceneList[0].pcGuidelineSceneParentCode;
        this.cCode1 = data[1].sceneList[0].pcGuidelineSceneCode;
        this.pCode1 = data[1].sceneList[0].pcGuidelineSceneParentCode;
        this.cCode2 = data[2].sceneList[0].pcGuidelineSceneCode;
        this.pCode2 = data[2].sceneList[0].pcGuidelineSceneParentCode;
        for (let i = 0; i < 3; i++) {
          this.typeOfService[i].sname = data[i].pcGuidelineSceneName;
          this.typeOfService[i].totalNum = data[i].count;
        }
        // this.drawPie(2, 'pie2', "32", )
      });
    },
    getGuideline1() {
      let data = "";
      for (let i = 0; i < this.$store.state.roleName.length; i++) {
        if (i == this.$store.state.roleName.length - 1) {
          data += this.$store.state.roleName[i].id;
        } else {
          data += this.$store.state.roleName[i].id + ",";
        }
      }
      let sendData = qs.stringify({
        sceneParentCode: "root",
        roleList: data,
        deptCode: localStorage.getItem("departCode"),
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guideline/findPortalHandlingGuidelineBySceneLogin",
        sendData
      ).then((res) => {
        this.listFlag = true;
        let data = res.dataList;
        // console.log(data)
        for (let i = 0; i < data.length; i++) {
          let data1 = data[i].sceneList;
          for (let j = 0; j < data1.length; j++) {
            let data2 = data1[j].guidelineList;
            for (let k = 0; k < data2.length; k++) {
              // data2[k].portalPcHandlingGuidelineImg = '/portal-ywtb/public/getImg?path=' +
              //   encodeURI(data2[k].portalPcHandlingGuidelineImg)
              data2[
                k
              ].portalPcHandlingGuidelineImg = `/portal-ywtb/${data2[k].portalPcHandlingGuidelineImg}`;
            }
          }
        }
        this.getGuidelineList = data;
        this.cCode0 = data[0].sceneList[0].pcGuidelineSceneCode;
        this.pCode0 = data[0].sceneList[0].pcGuidelineSceneParentCode;
        this.cCode1 = data[1].sceneList[0].pcGuidelineSceneCode;
        this.pCode1 = data[1].sceneList[0].pcGuidelineSceneParentCode;
        this.cCode2 = data[2].sceneList[0].pcGuidelineSceneCode;
        this.pCode2 = data[2].sceneList[0].pcGuidelineSceneParentCode;
        for (let i = 0; i < 3; i++) {
          this.typeOfService[i].sname = data[i].pcGuidelineSceneName;
          this.typeOfService[i].totalNum = data[i].count;
          this.typeOfService[i].isShow = data[i].isShow;
          if (data[i].isShow == "true") {
            this.serviceIndex = i;
            this.heightFlag += 1;
          } else {
            this.roleAuthFlag[i] = false;
          }
        }
        if (this.heightFlag == 0) {
          this.noYy = true;
        }
        // this.drawPie(2, 'pie2', "32", )
      });
    },
    // 好差评统计,各类事项占比
    drawPie000(flag, dom, legendTop) {
      var myChart = this.$echarts.init(document.getElementById(dom));
      var colorList, data, value;
      if (flag == 4) {
        colorList = ["#30AAF2", "#01D285", "#FDBA39", "#6F4DEA", "#FF3F3F"];
        data = ["非常满意", "满意", "基本满意", "不满意", "非常不满"];
        value = [
          {
            value: 90,
            name: "非常满意",
          },
          {
            value: 23,
            name: "满意",
          },
          {
            value: 27,
            name: "基本满意",
          },
          {
            value: 9,
            name: "不满意",
          },
          {
            value: 4,
            name: "非常不满",
          },
        ];
      } else if (flag == 2) {
        colorList = ["#6F4DEA", "#FDBA39", "#30AAF2", "#01D285"];
        data = [
          this.typeOfService[0].sname,
          this.typeOfService[1].sname,
          this.typeOfService[2].sname,
        ];
        value = [
          {
            value: this.typeOfService[0].totalNum,
            name: this.typeOfService[0].sname,
          },
          {
            value: this.typeOfService[1].totalNum,
            name: this.typeOfService[1].sname,
          },
          {
            value: this.typeOfService[2].totalNum,
            name: this.typeOfService[2].sname,
          },
          // {
          //   value: 33,
          //   name: '公开公示类'
          // }
        ];
      }
      var option = {
        title: {
          show: false,
          text: "各类事项数量占比",
          textStyle: {
            color: "#fff",
            fontSize: "16",
            fontFamily: "MicrosoftYaHei",
          },
          left: "150",
          top: "15",
          // textAlign:'center'
        },
        grid: {
          bottom: 120,
          left: 0,
          right: "10%",
        },
        legend: {
          show: true,
          orient: "vertical",
          top: legendTop,
          right: "20",
          icon: "circle",
          textStyle: {
            fontSize: 16,
            rich: {
              name: {
                color: "#fff",
                // align: 'right'
                // width: 60
              },
              percent: {
                color: colorList,
                fontSize: 18,
                padding: [0, 5, 0, 10],
                // align: 'right'
              },
            },
          },
          formatter: function (name) {
            // 获取legend显示内容
            let data = option.series[0].data;
            let total = 0;
            let tarValue = 0;
            for (let i = 0, l = data.length; i < l; i++) {
              total += data[i].value;
              if (data[i].name == name) {
                tarValue = data[i].value;
              }
            }
            let percent = ((tarValue / total) * 100).toFixed(2);
            return "{name| " + name + "}{percent|" + percent + "%}";
          },
          data: data,
        },
        series: [
          // 主要展示层的
          {
            radius: ["15%", "75%"],
            center: ["28%", "50%"],
            type: "pie",
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex];
                },
              },
            },
            label: {
              normal: {
                show: false,
              },
            },
            data: value,
          }, // 边框的设置
          {
            radius: ["86%", "88%"],
            center: ["28%", "50%"],
            type: "pie",
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            animation: false,
            tooltip: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "rgb(0, 157, 233,.34)",
              },
            },
            data: [
              {
                value: 1,
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
    },
    drawPies2() {
      // var myChart = this.$echarts.init(document.getElementById("pie3"));
      var data = [70, 30];
      var placeHolderStyle = {
        normal: {
          label: {
            // show: false
          },
          labelLine: {
            // show: false
          },
          color: "rgba(0,0,0,0)",
          borderWidth: 0,
        },
        // emphasis: {
        // color: "rgba(0,0,0,0)",
        // borderWidth: 0
        // }
      };
      var dataStyle = {
        normal: {
          position: "center",
          show: true,
          textStyle: {
            fontSize: "24",
            fontWeight: "normal",
            color: "#fff",
          },
          formatter(v) {
            return (
              Math.round((v.value / (data[0] + data[1])) * 10000) / 100.0 + "%"
            );
          },
        },
      };
      let option = {
        // backgroundColor: '#fff',
        title: [
          {
            text: "已入住事项",
            subtext: " 7789项",
            left: "29.8%",
            top: "70%",
            textAlign: "center",
            textStyle: {
              fontWeight: "normal",
              fontSize: "16",
              color: "#fff",
              textAlign: "center",
            },
          },
          {
            text: "未入住事项",
            subtext: " 7789项",
            left: "70%",
            top: "70%",
            textAlign: "center",
            textStyle: {
              color: "#fff",
              fontWeight: "normal",
              fontSize: "16",
              textAlign: "center",
            },
          },
        ],
        //第一个图表
        series: [
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["45%", "59%"],
            center: ["30%", "45%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: true,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: 100,
                itemStyle: {
                  normal: {
                    color: "#009de91a",
                  },
                },
              },
              {
                value: 35,
                itemStyle: placeHolderStyle,
              },
            ],
          },
          //上层环形配置
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["45%", "55%"],
            center: ["30%", "45%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: data[0],
                itemStyle: {
                  normal: {
                    color: "#00C0FF",
                  },
                },
                label: dataStyle,
              },
              {
                value: data[0] + data[1],
                itemStyle: placeHolderStyle,
              },
            ],
          },

          //第二个图表
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["45%", "59%"],
            center: ["70%", "45%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: 100,
                itemStyle: {
                  normal: {
                    color: "#009de91a",
                  },
                },
              },
              {
                value: 35,
                itemStyle: placeHolderStyle,
              },
            ],
          },

          //上层环形配置
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["45%", "55%"],
            center: ["70%", "45%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: data[1],
                itemStyle: {
                  normal: {
                    color: "#00D6A6",
                  },
                },
                label: dataStyle,
              },
              {
                value: data[0] + data[1],
                itemStyle: placeHolderStyle,
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
    },
    changeService(index) {
      this.serviceIndex = index;
    },
    tab0click(idx) {
      this.TabTitIdx0 = idx;
    },
    tab1click(idx) {
      this.TabTitIdx1 = idx;
    },
    tab2click(idx) {
      this.TabTitIdx2 = idx;
    },
    viewGuide(id, code) {
      this.$router.push({
        path: "/guide",
        query: {
          code,
        },
      });
    },
    byTheme(code) {
      this.$router.push("/search");
      localStorage.setItem("pcGuidelineSceneCode", code);
    },
    /**
     * @name getLtAndExecution
     * @description 登录前获取信息
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-01 09:43:15
     */
    async getLtAndExecution(param) {
      var serviceUrl =
        (window.serviceUrl ||
          "https://ywtb.zzuli.edu.cn/portal-ywtb/web/login") +
        `?url=${window.encodeURIComponent(window.location.href)}`;
      $.getJSON(
        // var requestUrl = 'http://192.168.30.37:8090';
        window.casUrl +
          "/cas/login?action=getlt&service=" +
          serviceUrl +
          "&callback=?",
        (response) => {
          // document.getElementById('lt').value = response.lt;
          // document.getElementById('execution').value = response.execution;
          // $('#loginForm').submit();
          // console.log(response);
          const { lt, execution } = response;
          this.globalDownload({
            method: "post",
            url:
              window.casUrl +
              "/cas/login?submit=%e7%99%bb++%e5%bd%95&service=" +
              serviceUrl,
            blank: "_self",
            data: {
              username: this.userName,
              password: this.passWord,
              lt,
              execution,
              _eventId: "submit",
            },
          });
        }
      );
      return;
      let obj = null;
      try {
        obj = await request({
          method: "get",
          url: "/portal-ywtb/web/casLogin",
          params: {
            username: this.userName,
            password: this.passWord,
          },
        });
      } catch (error) {
        //
        return;
      }
      if (obj.status == 200) {
        this.checkLogin();
      } else {
        this.$message({
          message: obj.msg || "登陆失败",
          type: "warning",
        });
      }
    },
    async login() {
      if (this.userName == "") {
        this.$message({
          message: "用户名不能为空",
          type: "warning",
        });
        return;
      }
      if (this.passWord == "") {
        this.$message({
          message: "密码不能为空",
          type: "warning",
        });
        return;
      }
      // 调用接口
      // getLtAndExecution
      await this.getLtAndExecution({
        username: this.userName,
        password: this.passWord,
      });
      // let sendData = qs.stringify({
      //   username: this.userName,
      //   password: this.passWord
      // })
      // this.ywtbRequest('/portal-ywtb/web/casLogin', sendData).then(res => {
      //     if (res.config === undefined && res.status === 200) {
      //       window.location.reload();
      //     } else {
      //         this.$message({
      //             message: res.data.msg,
      //             type: 'warning'
      //         });
      //         return
      //     }
      // })
    },
    // 获取部门新闻
    getDepartNew() {
      const code = this.$route.query.code;
      if (code === null || code === undefined || code === "") {
        return;
      }
      let sendData = qs.stringify({
        deptCode: code,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/news/findNewsByDeptCode",
        sendData
      ).then((res) => {
        var data = res.dataList || [];
        this.newsMore = res.data;
        if (data.length === 0) {
          this.noBs = true;
        }
        let data1 = [];
        let len;
        if (data.length > 5) {
          len = 5;
        } else {
          len = data.length;
        }
        for (let i = 0; i < len; i++) {
          data1.push(data[i]);
          data1[i].newDate = data[i].date.substring(5);
        }
        this.newsList = data1;
      });
    },
    newsJump(url) {
      window.open(url);
    },
    goUser(site0, site1) {
      if (site0 != undefined) {
        localStorage.setItem("userSite0", site0);
        localStorage.setItem("userSite1", site1);
      }
      this.$router.push("/user");
    },
    // 获取用户办事数量
    getUserNums() {
      let sendData = qs.stringify({
        userCode: this.$store.state.userCode,
      });
      this.ywtbRequest("/portal-ywtb/web/guideline/countGuidelineByScene").then(
        (res) => {
          let data = res.dataList;
          for (let i = 0; i < data.length; i++) {
            if (data[i].status == "办理中") {
              this.userNums.blz = data[i].count;
            } else if (data[i].status == "已办结") {
              this.userNums.ybj = data[i].count;
            }
          }
        }
      );
      this.getNewMsg0();
      this.getWddbMsg();
    },
    // 获取我的咨询新动态数量
    getNewMsg0() {
      let sendData = qs.stringify({
        memberId: this.$store.state.userId,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/consultation/findNewConsultationByMemberId",
        sendData
      ).then((res) => {
        this.userNums.wdzx = res.count;
      });
    },
    // 获取我的待办个数
    getWddbMsg() {
      let sendData = qs.stringify({
        pageNum: 1,
        pageSize: 10,
        resultType: 0,
      });
      this.ywtbRequest("/portal-ywtb/web/process/findWork", sendData).then(
        (res) => {
          this.userNums.wddb = res.count;
        }
      );
    },
    //服务成效统计*********************************
    getStatistics() {
      // 各类事项占比
      // this.ywtbRequest('/portal-ywtb/web/indexStatistics/guidelineTypeRatio').then(res => {
      // this.drawPie(2, 'pie2', "32", )
      // })
      // 平均办理时长
      this.ywtbRequest("/portal-ywtb/web/indexStatistics/avgHandleTime").then(
        (res) => {
          // this.drawPies1(res.data)
          let time = res.data.avgTime;
          this.pie_1.num = res.data.guidelinbCount;
          let arr = time.split("天");
          this.pie_1.day = arr[0];
          let arr_1 = arr[1].split("小时");
          this.pie_1.hour = arr_1[0];
        }
      );
      this.ywtbRequest(
        "/portal-ywtb/web/indexStatistics/findSuggestionRatio"
      ).then((res) => {});
    },
    // 今日办理数量,今日办结数量
    getBjNums(flag) {
      Date.prototype.Format = function (fmt) {
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
        return fmt;
      };
      let daySart = new Date(
        new Date(new Date().toLocaleDateString()).getTime()
      );
      let dayEnd = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
      let sendData = qs.stringify({
        startTime: daySart.Format("yyyy-MM-dd hh:mm:ss"),
        endTime: dayEnd.Format("yyyy-MM-dd hh:mm:ss"),
        status: flag,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/indexStatistics/findGuidelineByProcessTime",
        sendData
      ).then((res) => {
        // console.log(res)
      });
    },
  },
  watch: {
    "$store.state.isLogin"() {
      this.getGuideline1();
      this.getUserNums();
    },
    typeOfService(val) {
      // console.log(this.typeOfService)
    },
  },
};
</script>

<style lang="scss" scoped>
h2.partName {
  color: #fff;
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 28px;
}

.headerAndNav {
  background: linear-gradient(
    0deg,
    rgba(12, 50, 135, 1) 0%,
    rgba(10, 46, 129, 1) 100%
  );
}

.topQuery {
  background: url(../../../static/images/partBg.png) no-repeat -1px 0;
  background-size: 101% 101%;
}

h2.partName span {
  font-size: 24px;
}

.hotIssues {
  height: 198px;
}

.topQuery .notLogin .directBox > div.box3 {
  height: 241px;
}

.topQuery .notLogin .directBox .box1.loginBox {
  width: 303px;
  height: 241px;
  padding: 5px 20px;
}

.topQuery .notLogin .directBox .box1.loginBox h3 {
  text-align: center;
  line-height: 40px;
  margin-bottom: 10px;
  color: #333;
  font-size: 20px;
  font-weight: 600;
  font-family: PingFang SC;
}

.uerName,
.passWord {
  margin-bottom: 20px;
}

.loginBtn {
  width: 129px;
  height: 35px;
  background: rgba(20, 90, 182, 1);
  border-radius: 3px;
  color: #fff;
  padding: 10px 20px;
}

button.forgetBtn {
  width: 129px;
  height: 35px;
  background: rgba(200, 7, 14, 1);
  border-radius: 3px;
  color: #fff;
  padding: 10px 20px;
  margin-left: 0px;
}

.topQuery .right.logined {
  height: 300px;
}

.right.logined .grxx {
  padding: 10px 13px 10px 24px;
  width: 100%;
}

.ywtbUserInfo {
  height: 113px;
}

.grxx .userMatterList li {
  width: 137px;
  margin-right: 10px;
}
.grxx .userMatterList li.marginR0 {
  margin-right: 0;
}
.serviceContent .serviceContentBox {
  width: 100%;
  height: auto;
  position: static;
  min-height: 360px;
  /* margin-top: 10px; */
  /* transition: all 0.3s; */
}

.serviceContent {
  width: 100%;
  height: auto;
  min-height: 370px;
  position: relative;
}

.serviceContent.height_1 {
  height: 370px;
}

.serviceContent.height_2 {
  height: 740px;
}

.noData {
  text-align: center;
  padding-top: 60px;
}

.noData p {
  margin-top: 15px;
  font-size: 16px;
  color: #9eafcb;
}

.bsqsData.noData {
  padding-top: 0px;
}

.mutil-line-ellipsis {
  width: 100%;
  height: 40px;
  line-height: 20px;
  // margin: 20px 20px 50px 300px;
  border: 0px solid #aaa;
  line-height: 20px;
  overflow: hidden;
}

.guideline_image {
  margin-top: 20px;
}
/*相当于之前的prop*/

.mutil-line-ellipsis:before {
  content: "";
  float: left;
  width: 5px;
  /*缩小宽度为5px，其余属性不变*/
  height: 50px;
}
/*相当于之前的main*/

.mutil-line-ellipsis > :first-child {
  float: right;
  width: 100%;
  margin-left: -5px;
  /*让main元素左移5px，这样main元素在宽度上就完全占满了父元素；*/
  word-break: break-all;
}
/*相当于之前的realEnd*/

.mutil-line-ellipsis:after {
  content: "...";
  box-sizing: content-box;
  float: right;
  position: relative;
  width: 50px;
  height: 25px;
  top: -28px;
  /*等于高度的负值，就是文字的行高*/
  left: 100%;
  /*而设置margin-left: -50px、padding-right: 5px则是为了让realend元素的盒模型的最终宽度计算为5px。*/
  margin-left: -50px;
  padding-right: 5px;
  font-size: 13px;
  text-align: right;
  // background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff 40px);
  background-color: #fff;
  width: 25px;
  margin-left: -25px;
  text-align: left;
  text-indent: 5px;
}

.guideline_list_wrap {
  &.template1 {
    background-color: #f4f5f9;
  }
  &.template2 {
    background-color: #fff;
  }
  &.template3 {
    background-color: #fff;
  }
  width: 100%;
  .guideline_list_box {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 20px;
  }
}

.page_wrap {
  text-align: center;
}
.ywtbListsContent {
  padding: 10px 10px;
}

.ywtbListsContent li {
  float: left;
  width: 285px;
  // height: 110px;
  height: 132px;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  position: relative;
  padding: 17px 18px 0 96px;
  margin: 10px 5px;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.05);
}

.ywtbListsContent li .iconfont {
  /* position: absolute; */
  /* right: 10px; */
  /* top: 6px; */
  color: #c5c5c5;
  /* display: none; */
  cursor: pointer;
}

.ywtbListsContent li:hover .iconfont {
  // display: block;
}

.ywtbListsContent li .iconfont.active {
  color: #fa1818;
}

.ywtbListsContent li:hover {
  border: 1px solid rgba(233, 26, 34, 1);
  box-shadow: 0px 0.25rem 1.25rem rgba(233, 26, 34, 0.2);
}

.ywtbListsContent li > img {
  width: 60px;
  height: 60px;
  position: absolute;
  // top: 23px;
  top: 20px;
  left: 18px;
}

.ywtbListsContent li > h3 {
  font-size: 16px;
  font-weight: 700;
  color: #4b4f58;
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ywtbListsContent li > p {
  margin-top: 10px;
  width: 216px;
  height: 40px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #95a1b7;
}

.ywtbListsContent li > a {
  width: 78px;
  padding: 4px 12px;
  border: 1px solid rgba(71, 114, 189, 1);
  border-radius: 4px;
  // margin-top: 20px;
  margin-top: 4px;
  margin-left: 3px;
}

.ywtbListsContent li .znBtn {
  color: #4772bd;
  background-color: #fff;
}

.ywtbListsContent li .blBtn {
  color: #fff;
  background-color: #4772bd;
}
.collection_wrap {
  position: absolute;
  left: 0;
  bottom: 14px;
  // display: none;
  left: 20px;
  font-size: 12px;
  cursor: pointer;
  .iconfont {
    font-size: 14px;
    display: inline-block;
    transform: translateY(1px);
  }
  span {
    color: #aaa;
  }
  &.active {
    .iconfont,
    span {
      color: rgb(247, 186, 42) !important;
      // color: #fa1818;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/DepartmentHomepage.vue